import { render, staticRenderFns } from "./SafeManagement.vue?vue&type=template&id=5e483ba2&scoped=true"
import script from "./SafeManagement.vue?vue&type=script&lang=ts"
export * from "./SafeManagement.vue?vue&type=script&lang=ts"
import style0 from "./SafeManagement.vue?vue&type=style&index=0&id=5e483ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e483ba2",
  null
  
)

export default component.exports